const MAX_ZOOM_FOR_SINGLE_RESULT = 15;
const MAX_AVAILABLE_ZOOM_LEVEL = 21;
const MAP_LABEL_DEBOUNCE_DELAY = 10;
const MAP_LABEL_MOUSE_POINTER_X_OFFSET = 0;
const MAP_LABEL_MOUSE_POINTER_Y_OFFSET = 15;
const MAP_POLYGON_COLOR_DEFAULT = '#e58e1a';
const MAP_POLYGON_COLOR_ACTIVE = '#e58e1a';
const MAP_POLYGON_OPACITY_DEFAULT = 0.3;
const MAP_POLYGON_OPACITY_ACTIVE = 0.65;
const DL_BY_GEO_CODE_API_URL = '/apirequest/dealer-locator/get-dealer-by-geo-code';
const DL_BY_GEO_FILTER_API_URL = '/apirequest/dealer-locator/get-dealer-by-geographic-filter';
const DL_BY_DEALER_NUMBER_API_URL = '/apirequest/dealer-locator/get-dealer-by-dealer-number';
const DL_BY_DEALER_COUNTRY_API_URL = '/apirequest/dealer-locator/get-dealer-by-country';
const COUNTRIES_COLLECTION_NAME = 'countries';
const STATES_COLLECTION_NAME = 'states';
const USER_ABORTED_REQUEST_CODE = 20;
const DL_MAP_ID = 'cnhi-dealer-locator-map';
const DL_GOOGLE_MAP_ID = 'DEMO_MAP_ID';

const DL_QUERY_STRINGS = {
  SEARCH_QUERY: 'query',
  USER_LATITUDE: 'ulat',
  USER_LONGITUDE: 'ulng',
  COUNTRY: 'country',
  REGION: 'region',
  EQUIPMENT_FILTERS: 'eqFilters',
  SERVICES_FILTERS: 'seFilters',
  SELECTED_DEALER: 'dealerId',
  PLACE_ID: 'placeId',
};

export {
  MAX_ZOOM_FOR_SINGLE_RESULT,
  MAX_AVAILABLE_ZOOM_LEVEL,
  MAP_LABEL_DEBOUNCE_DELAY,
  MAP_LABEL_MOUSE_POINTER_X_OFFSET,
  MAP_LABEL_MOUSE_POINTER_Y_OFFSET,
  MAP_POLYGON_COLOR_DEFAULT,
  MAP_POLYGON_COLOR_ACTIVE,
  MAP_POLYGON_OPACITY_DEFAULT,
  MAP_POLYGON_OPACITY_ACTIVE,
  DL_BY_GEO_CODE_API_URL,
  DL_BY_GEO_FILTER_API_URL,
  DL_BY_DEALER_NUMBER_API_URL,
  DL_BY_DEALER_COUNTRY_API_URL,
  COUNTRIES_COLLECTION_NAME,
  STATES_COLLECTION_NAME,
  USER_ABORTED_REQUEST_CODE,
  DL_QUERY_STRINGS,
  DL_MAP_ID,
  DL_GOOGLE_MAP_ID,
};
